import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeleteBookmarkPayload {
  bookmarkId: string;
}

interface DeleteBookmarkState {
  loading: boolean;
  delete_error: string | null;
  delete_success: boolean;
}

const initialState: DeleteBookmarkState = {
  loading: false,
  delete_error: null,
  delete_success: false,
};

const deleteBookmarkSlice = createSlice({
  name: 'deleteBookmark',
  initialState,
  reducers: {
    deleteBookmarkRequest: (state, _action: PayloadAction<DeleteBookmarkPayload>) => {
      state.loading = true;
      state.delete_error = null;
      state.delete_success = false;
    },
    deleteBookmarkSuccess: (state) => {
      state.loading = false;
      state.delete_success = true;
    },
    deleteBookmarkFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.delete_error = action.payload;
    },
  },
});

export const { deleteBookmarkRequest, deleteBookmarkSuccess, deleteBookmarkFailure } = deleteBookmarkSlice.actions;
export const deleteBookmarkReducer = deleteBookmarkSlice.reducer;
export const deleteBookmarkActionTypes = deleteBookmarkSlice.actions;
